import React from "react";
import { THEME_COLORS } from "../../../../../../color";

const Tier1SupplierTable = ({ getComponent, activeDashboard }) => {
  // Sample data
  let tableData = [
    { supplier: "Total number of tier 1 supplier", value: "300" },
    { supplier: "Total number of critical Supplier in Tier 1", value: "60" },
    {
      supplier: "Percentage of total spend on critical Supplier in Tier 1",
      value: "40%",
    },
    {
      supplier: "Total number of critical Supplier in non-Tier 1",
      value: "30",
    },
    {
      supplier: "Total number of critical Supplier (Tier 1 and non-Tier 1)",
      value: "90",
    },
  ];

  const comp = getComponent ? getComponent("sc_tier1_breakdown") : null;

  if (activeDashboard === "live" && comp?.data && Array.isArray(comp.data)) {
    tableData = [
      {
        supplier: "Total number of tier 1 supplier",
        value: String(comp.data[0]?.value ?? 0),
      },
      {
        supplier: "Total number of critical Supplier in Tier 1",
        value: String(comp.data[1]?.value ?? 0),
      },
      {
        supplier: "Percentage of total spend on critical Supplier in Tier 1",
        value: `${comp.data[2]?.value ?? 0}%`,
      },
      {
        supplier: "Total number of critical Supplier in non-Tier 1",
        value: String(comp.data[3]?.value ?? 0),
      },
      {
        supplier: "Total number of critical Supplier (Tier 1 and non-Tier 1)",
        value: String(comp.data[4]?.value ?? 0),
      },
    ];
  }

  return (
    <div className="py-4 px-2 sm:px-4 md:px-6 lg:px-8 h-full flex flex-col">
      {/* Responsive wrapper for horizontal scroll on small screens */}
      <div className="w-full overflow-x-auto border border-[#efefef] rounded-md flex-1 flex flex-col">
        <table className="min-w-full table-auto border-collapse h-full">
          {/* Table Header */}
          <thead>
            <tr className="bg-[#E5F3F6] text-[12px] sm:text-[13px]">
              <th
                className="w-3/5 px-3 py-3 sm:px-4 sm:py-4 text-left font-calibri font-bold border-r border-[#efefef]"
                style={{ color: THEME_COLORS.green }}
              >
                Tier 1 Supplier Breakdown
              </th>
              <th
                className="w-2/5 px-3 py-3 sm:px-4 sm:py-4 text-left font-calibri font-bold"
                style={{ color: THEME_COLORS.green }}
              >
                {activeDashboard === "live" ? "Current Period" : "FY 2022-23"}
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="h-full">
            {tableData.map((item, index) => (
              <tr
                key={index}
                className="bg-white text-[13px] sm:text-[14px] border-b border-[#3BA2B959] h-full"
                style={{ height: `calc((100% - 48px) / ${tableData.length})` }}
              >
                <td className="px-3 py-4 sm:px-4 sm:py-5 border-r border-[#efefef] font-light text-left align-middle">
                  {item.supplier}
                </td>
                <td className="px-3 py-4 sm:px-4 sm:py-5 text-center align-middle">
                  {item.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tier1SupplierTable;
